export default __webpack_public_path__ + "static/media/drawingwebgl.a76ef14c.webp";